module.exports = __webpack_public_path__ + "static/media/r22.d9d3ef09.jpg";